//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import StarIcon from "~/components/icons/StarIcon.vue";

export default {
    name: "CustomStarRate",
    components: { StarIcon },
    props: {
        value: {
            type: Number,
            default: 0,
        },
        type: {
            type: String,
        },
    },
    data() {
        return {
            rating: this.value,
            currentHover: 0,
        };
    },
    methods: {
        setHover(star) {
            this.currentHover = star;
        },
        resetHover() {
            this.currentHover = 0;
        },
        setRating(star) {
            this.rating = star;
            this.$emit("input", star);
        },
    },
    watch: {
        value(newVal) {
            this.rating = newVal;
        },
    },
};
